import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import {apiUrl} from "../../environments/environment";
import {Floor} from "../_models/floor";
import {Observable} from "rxjs";
import {Area} from "../_models/area";
import {Comment} from "../_models/comment";
import {tap} from "rxjs/operators";
import {DomSanitizer} from "@angular/platform-browser";
import {HistoryItem} from "../_models/historyItem";

@Injectable({
  providedIn: 'root'
})
export class FloorsService {

  constructor(private http: HttpClient, private domSanitizer: DomSanitizer) { }


  getFloorsShortList(projectId: number, sectionId?: number | null) {
    let params = new HttpParams().set('projectId', String(projectId));
    if (sectionId) params = params.set('sectionId', String(sectionId));
    return this.http.get<Floor[]>(`${apiUrl}/floor/short`, {params, withCredentials: true})
  }

  getFloorsShortListWithDates(projectId: number) {
    return this.http.get<Floor[]>(`${apiUrl}/floor/short-with-dates`, {params: {projectId: projectId}, withCredentials: true})
  }

  getFloorById(floorId: number, sectionId?: number | null) {
    let params = new HttpParams();
    if (sectionId) params = params.set('sectionId', String(sectionId));
    return this.http.get<Floor>(`${apiUrl}/floor/${floorId}`, {params, withCredentials: true})
  }

  getFloorByPublicId(publicId: string) : Observable<Floor> {
    const params = new HttpParams().set('publicId', publicId)
    return this.http.get<Floor>(`${apiUrl}/floor`, {params: params, withCredentials: true}).pipe(tap(el => {
      el.comments.forEach(e => {
        e.safeHtml = this.domSanitizer.bypassSecurityTrustHtml(e.html);
      });
    }))
  }

  createFloor(projectId: number, floorName: string | null, duplicateFloorId: number | null, sectionId?: number | null) {
    let params = new HttpParams()
    params =  params.append('projectId', String(projectId))
    if (floorName) params =  params.append('floorName', floorName)
    if (duplicateFloorId) params = params.append('duplicateFloorId', duplicateFloorId)
    if (sectionId) params = params.append('sectionId', String(sectionId))
    return this.http.post<Floor>(`${apiUrl}/floor`, null,  {params: params, withCredentials: true})
  }

  updateFloorNameById(floorId: number, floorName: string, version: number) {
    let params = new HttpParams().append('newName', floorName).append('version', version);
    return this.http.put(`${apiUrl}/floor/${floorId}/name`, null, {params: params, withCredentials: true})
  }

  updateFloorOrderById(newOrder: number, floorId: number) {
    return this.http.put(`${apiUrl}/floor/${floorId}/order?newOrder=${newOrder}`, null, {withCredentials: true})
  }

  deleteFloorById(floorId: number) {
    let params = new HttpParams();
    params = params.append('floorId', floorId);
    return this.http.delete(`${apiUrl}/floor`, {params: params, withCredentials: true})
  }

  //Activity Floor

  updateDates(floorId: number, startDate: number, endDate: number) {
    let params = new HttpParams();
    if(startDate) params.append('startDate', startDate);
    if(endDate) params.append('endDate', endDate);
    return this.http.put(`${apiUrl}/floor/${floorId}/date`, null, {params: params, withCredentials: true})
  }

  getComments(floorId: number): Observable<Comment[]> {
    return this.http.get<Comment[]>(`${apiUrl}/floor/comment`, {params: {floorId}, withCredentials: true})
  }

  createComment(floorId: number, comment: FormData): Observable<Comment> {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    return this.http.post<Comment>(`${apiUrl}/floor/comment`, comment, {params: {floorId}, headers: headers, withCredentials: true})
  }

  editComment(comment: FormData): Observable<Comment> {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    return this.http.put<Comment>(`${apiUrl}/floor/comment`, comment, {withCredentials: true})
  }

  deleteComment(commentId: number) {
    return this.http.delete(`${apiUrl}/floor/comment`, {params: {commentId}, withCredentials: true})
  }

  //History

  getHistory(id: number): Observable<HistoryItem[]> {
    return this.http.get<HistoryItem[]>(`${apiUrl}/floor/${id}/history`, {withCredentials: true})
  }

}
